module.exports = __webpack_public_path__ + "static/media/logo-quality-small.509b15fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-quality-small.svg
// module id = 328
// module chunks = 0